// Shared attacks of the alliance (G-70): soonest first, each with Reinforce (P31).
import type { MemberAlliance } from '@stars-and-ships/api-types';
import { Link } from 'react-router';
import { useAllianceAttacks } from '../../api/queries';
import { reinforceLink } from '../../fleetTiming';
import { formatDuration, formatShips, MISSION_LABELS } from '../../labels';
import { useSystemNames } from '../../screens/fleet';
import { useNow } from '../../state/live';
import { PlayerLink } from '../ProfileLinks';
import { ErrorNotice, Panel, Spinner } from '../ui';

export function AttacksTab({ galaxyId, alliance }: { galaxyId: string; alliance: MemberAlliance }) {
  const attacks = useAllianceAttacks(galaxyId, alliance.id);
  const name = useSystemNames(galaxyId);
  const now = useNow();
  if (attacks.isPending) return <Spinner />;
  if (attacks.error) return <ErrorNotice error={attacks.error} />;
  return (
    <Panel title="Shared attacks">
      {attacks.data.items.length === 0 ? (
        <p className="text-sm text-muted">
          No shared attacks. Share an attack when sending a fleet.
        </p>
      ) : (
        <ul className="space-y-2">
          {attacks.data.items.map((a) => (
            <li
              key={a.id}
              data-attack={a.id}
              className="hud-cut-sm border border-line bg-void/60 p-3 text-sm"
            >
              <p className="text-text">
                <PlayerLink
                  galaxyId={galaxyId}
                  playerId={a.owner.playerId}
                  name={a.owner.displayName}
                />{' '}
                · {MISSION_LABELS[a.mission]} → {name(a.targetSystemId)}
              </p>
              <p className="truncate text-xs text-muted">
                from {name(a.originSystemId)} · {formatShips(a.ships)}
              </p>
              <p className="font-mono text-xs tabular-nums text-info">
                arrives in {formatDuration(Date.parse(a.arriveAt) - now)} ·{' '}
                {new Date(a.arriveAt).toLocaleString()}
              </p>
              <Link
                to={reinforceLink(galaxyId, {
                  targetSystemId: a.targetSystemId,
                  mission: a.mission,
                  arriveAt: a.arriveAt,
                })}
                className="mt-1 inline-block text-xs text-info underline"
              >
                Reinforce
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
}
